import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { OffersByProductIdResponseDto } from '@hub-la/sdk-bff-product'
import { inject } from 'inversify'
import { ListOffersInput } from '../domain/dtos/list-offers-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class ListOffers {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<OffersByProductIdResponseDto>,
  ) {}

  public async execute(
    input?: ListOffersInput,
    signal?: AbortSignal,
  ): Promise<OffersByProductIdResponseDto | undefined> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input?.productId}/offers`,
      params: {
        page: input?.page,
        pageSize: input?.pageSize,
      },
      signal,
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response?.data
    }

    throw new GeneralError()
  }
}
